import React from 'react';
import { Link } from 'react-router-dom';

function NotFoundPage() {
  return (
    <main className="not-found-page section-shell">
      <span className="eyebrow">404 · Page not found</span>
      <h1>We couldn’t find that page</h1>
      <p>The link may have changed, or the page may no longer be available.</p>
      <Link to="/" className="button primary gradient-btn">Back to home</Link>
    </main>
  );
}

export default NotFoundPage;